export const VARIANT_NEW = "new";

export const VARIANTS_CLASS_NAMES = {
    // no class name for the default value
    "": "",
    [VARIANT_NEW]: "variant-new",
};
